export default __webpack_public_path__ + "4cf8d7739a7be174b8bff6836771273e.svg";